<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >   
       <div v-if="needInit">{{initData()}}</div>  
       
       <v-layout row wrap>
            <v-flex xs6> <v-card outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <a-lesson v-bind:ltype="1"></a-lesson>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <a-lesson v-bind:ltype="2"></a-lesson>
            </v-card>  </v-flex>
            <v-flex xs12>
                <v-card outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-flex xs4>
                            <p>Chapter:
                                <v-menu v-if="chapterList.length > 0" transition="slide-y-transition" bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn large class="my-3" color="primary" v-on="on">
                                            {{ chapterList[chapterIndex].name}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in chapterList"
                                            :key="index"
                                            @click="chapterIndex = index; chapterID = item.id;"
                                        >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>  
                                </v-menu>
                            </p>
                        </v-flex>
                            <v-flex xs6>
                                <v-card outlined>
                                    <v-btn @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ALesson from '../../../elements/ALesson.vue'
import LanguageList from '../../../elements/LanguageList.vue'
import {mapGetters} from 'vuex'
import axios from '../../../../axios-auth.js'

export default {
    data() {
        return {    
            runSaving: false,
            closeAfterSaving: false,
            contenUni: null,
            myID : 0,
            chapterID: 0,
            myOrder : 0,
            needInit : true,
            chapterIndex : 0,
            chapterList: []


        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContentUni',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig'
                    ])
    ,
    components: {
        ALesson,
        LanguageList
    },
    methods : {
        prepareDataforSave() {
            this.$store.commit('setFeedback', null)
            //// xxxxx check data - are there some data to fill?

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContentUni

            this.contentUni = {
                lesson_id : this.myID,
                chapter_id : this.chapterID,
                lesson_order : this.myOrder,
                content_list: []
            }
            
            for(var key in data) {
                this.contentUni.content_list.push( {
                    lang_id : key.replace('l',''),
                    content :  data[key]
                })
            }

            // axios
            axios.post('/create-edit-lesson-all-lang', this.contentUni, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })     
        },
        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'course_admin_content', params: {id: JSON.parse(localStorage.getItem('position')).activeCourse.id}})
        },
        initData() {
            this.needInit = false
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.myID = this.$route.params.id

            if (this.$route.params.id == '0') {
                this.$store.commit('prepareUni','default')
                this.chapterID = JSON.parse(localStorage.getItem('position')).activeChapter.id
            } else {
                // load existing data
                axios.get('/get-lesson-in-all-lang/' + this.$route.params.id, this.$store.getters.getAxiosConfig )
                .then(res => {
                    const data = {                        
                        cType: 'default',
                        content_list : res.data.list
                    }

                    this.$store.dispatch('setFullContentUni', data)
                    this.chapterID = res.data.chapter_id
                    this.myOrder = res.data.lesson_order 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            }
            
            axios.get('/course-preview/' + JSON.parse(localStorage.getItem('position')).activeCourse.id, this.$store.getters.getAxiosConfig )
            .then(res => {
                this.chapterIndex = 0
                this.chapterList = []
                for(let i = 0; i < res.data.chapterlist.length; i++) {
                    this.chapterList.push( {
                        id: res.data.chapterlist[i].chapter_id,
                        name: res.data.chapterlist[i].name
                    })
                    // set index in list
                    if (res.data.chapterlist[i].chapter_id == this.chapterID) this.chapterIndex = i
                }
            })
            .catch(error => {
                    this.$store.commit('setFeedback', error)
            }) 
            
        }
    },
    mounted() {
        this.needInit = true
    }      
     
}
</script>


